import { ExpressionValidationResultDc } from "@evergis/api";
import { RootState } from "../reducers";

export const getValidationError = ({ validation }: RootState): Error | null => validation?.error;

export const getValidationServerError = ({ validation }: RootState): ExpressionValidationResultDc | null =>
  validation?.serverError;
